// ----------------------------------------------------------------------

function path(root: string, sublink: string) {
  return `${root}${sublink}`;
}

const ROOTS = '/';

// ----------------------------------------------------------------------

export const PATHS = {
  root: ROOTS,
  main: path(ROOTS, 'main'),
  invite: path(ROOTS, 'invite'),
  additionalData: path(ROOTS, 'additional-data'),
  skillLevel: path(ROOTS, 'skill-lvl'),
  extractSkills: path(ROOTS, 'extract-skills'),
  profile: path(ROOTS, 'profile'),
  analysis: path(ROOTS, 'analysis'),
  interviews: path(ROOTS, 'interviews'),
  settings: path(ROOTS, 'settings'),
  results: path(ROOTS, 'results/:id'),
  sharedResults: path(ROOTS, 'shared/results/:id'),
  chat: path(ROOTS, 'chat'),
  videoInterview: {
    record: path(ROOTS, 'video-interview/record'),
    candidate: path(ROOTS, 'video-interview/candidate'),
    checkDevices: path(ROOTS, 'video-interview/check-devices')
  },
  payment: 'payment/:formId',
  paymentSuccess: 'payment/success',
  paymentFail: 'payment/fail',
  paymentHrInvitations: 'payment/hr-invitations/:formId',
  hr: {
    newCompany: path(ROOTS, 'hr/new-company'),
    newVacancy: path(ROOTS, 'hr/new-vacancy'),
    company: path(ROOTS, 'hr/company'),
    vacancy: path(ROOTS, 'hr/vacancy/:id'),
    vacancyStats: path(ROOTS, 'hr/vacancy/:vacancyId/stats'),
    candidateResult: path(ROOTS, 'hr/vacancy/:vacancyId/candidate-result/:userId')
  },
  requestedInterviews: {
    checkDevices: path(ROOTS, 'requested-interviews/check-devices/:id'),
    interview: path(ROOTS, 'requested-interviews/interview/:id'),
    vacancyInfo: path(ROOTS, 'requested-interviews/vacancy-info/:id')
  }
};

export const paths = PATHS;
